const actions = {
    SOCKET_CONNECTING:  'SOCKET_CONNECTING',
    SOCKET_CONNECTED:   'SOCKET_CONNECTED',
    SOCKET_DISCONNECTED:'SOCKET_DISCONNECTED',

    connecting:   () => ({ type: actions.SOCKET_CONNECTING }),
    connected:    () => ({ type: actions.SOCKET_CONNECTED }),
    disconnected: () => ({ type: actions.SOCKET_DISCONNECTED }),
};

export default actions;
